import React, { useEffect, useState } from "react";
import {
  FaArrowUp,
  FaWhatsapp,
  FaInstagram,
  FaLinkedin,
  FaXTwitter,
  FaRobot
} from "react-icons/fa6";
import "./FloatingButtons.css";

export default function FloatingButtons() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 200);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="floating-btn-wrapper">

      {/* WhatsApp */}
      <a
        href="https://wa.me/919944662747"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn whatsapp-btn"
      >
        <FaWhatsapp />
      </a>

      {/* Instagram */}
      <a
        href="https://instagram.com/yourprofile"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn insta-btn"
      >
        <FaInstagram />
      </a>

      {/* LinkedIn */}
      <a
        href="https://linkedin.com/company/yourcompany"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn linkedin-btn"
      >
        <FaLinkedin />
      </a>

      {/* Twitter / X */}
      <a
        href="https://twitter.com/yourprofile"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn twitter-btn"
      >
        <FaXTwitter />
      </a>


      {/* Scroll to Top */}
      {showScrollTop && (
        <button className="floating-btn scrolltop-btn" onClick={scrollToTop}>
          <FaArrowUp />
        </button>
      )}
    </div>
  );
}
